module.exports = __webpack_public_path__ + "img/krivorotko.9ea77c19.jpg";